import React, { useState, useRef } from 'react';

import { Button, Modal } from 'antd';

import PhoneBookForm from '../phone-book-form';
import { validateGuid } from '../../../../../../shared/utils';

const PhoneBookModal = ({ rootContainer, insuredId, policyId, onContactSelected }) => {
  const [visible, setVisible] = useState(false);

  const childRef = useRef();

  const handleOkClick = () => {
    if (typeof onContactSelected === 'function') {
      const { emails, fax } = childRef.current.getSelectedContactInfo();

      onContactSelected(emails, fax);
    }

    setVisible(false);
  };

  return (
    <>
      <Button ghost type="primary" size="small" onClick={() => setVisible(true)}>
        Phone book
      </Button>

      <Modal
        width={800}
        destroyOnClose={true}
        title="Phone book"
        open={visible}
        onOk={handleOkClick}
        onCancel={() => setVisible(false)}
        okText="Select"
        cancelText="Close"
        okButtonProps={{ size: 'middle' }}
        cancelButtonProps={{ size: 'middle' }}
        getContainer={rootContainer}
      >
        <PhoneBookForm ref={childRef} insuredId={validateGuid(insuredId)} policyId={validateGuid(policyId)} onContactSelected={onContactSelected} />
      </Modal>
    </>
  );
};

export default PhoneBookModal;
